<div class="bg-col-w col-b p-l overflow-y-auto no-scrollbar"
     style="height:100vh;">
    <off-canvas-search-tray class="m-t-3 w-12"
                            searchId="off-canvas"
                            [contentBlockData]="content"></off-canvas-search-tray>
</div>
